import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import { en, es, ptBR } from 'vuejs-datepicker/dist/locale'
import { JWTService } from '@/shared/services/jwt'

import Datepicker from 'vuejs-datepicker'

import SinisterHeader from '@/components/regulation/auto/sinisterheader/sinisterheader.vue'
import SinisterRegulationForms from './sinisterregulation-form'
import SinisterRegulationModel from './sinisterregulation-model'

import RegulationAutoSpecifyRepository from '@/shared/http/repositories/regulation/auto/regulationautospecify'

import RegulationMixin from '@/store/module/regulation/mixin'
import ExpertMixin from '@/store/module/expert/mixin.js'

export default {
  name: 'SinisterRegulation',
  props: ['clear'],
  mixins: [
    ActionsForm,
    ExpertMixin,
    RegulationMixin
  ],
  data () {
    return {
      data: SinisterRegulationModel,
      form: SinisterRegulationForms,
      regulationAutoId: null,
      en: en,
      es: es,
      ptBR: ptBR,
      disableActionDateRegulation: false
    }
  },
  components: {
    Datepicker,
    SinisterHeader
  },
  computed: {
    canReprogram () {
      return (
        this.form.typeConclusion.value === 3 &&
        (this.form.reasonFrustration.value === 2 ||
          this.form.reasonFrustration.value === 3)
      )
    }
  },
  watch: {
    // TODO RETIRAR APÓS REFACTOR
    clear: function () {
      this.onClear()
    }
  },
  mounted () {
    this.onLoad()
  },
  methods: {
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
    },
    onLoad () {
      this.onClear()
      this.form.actionDate.value = this.moment().format('YYYY-MM-DD hh:mm:ss')

      if (this.hasRegulation) {
        this.data.regulationAutoID = this.regulation.id
        this.form.regulationAutoID.value = this.regulation.id
        RegulationAutoSpecifyRepository.GetByRegulationAutoID(this.regulation.id)
          .then((response) => {
            var result = this.onResultObj(response)
            this.form.id.value = '00000000-0000-0000-0000-000000000000'
            if (result !== null) {
              this.form.id.value = result.id
              this.form.typeConclusion.value = result.typeConclusion
              this.form.reasonFrustration.value = result.reasonFrustration
              this.form.lossType.value = result.lossType
              this.form.budget.value = result.budget
              this.form.engineNumber.value = result.engineNumber
              this.form.description.value = result.description
              if (result.actionDate) {
                this.form.actionDate.value = result.actionDate
                this.disableActionDateRegulation = true
              } else {
                this.disableActionDateRegulation = false
              }
            }
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onSave () {
      var self = this
      if (!this.form.id.value) {
        this.form.id.value = '00000000-0000-0000-0000-000000000000'
      }
      this.data.id = this.form.id.value
      this.form.regulationAutoID.value = this.regulation.id
      if (Tools.ValidateForms(this.form, this.data, self)) {
        // Set default data
        this.data.dateUpdate = this.moment().format('YYYY-MM-DD hh:mm:ss')
        this.data.accountIDUpdate = JWTService.GetTokenPayload().AccountID
        if (this.data) {
          this.data.status = 1
          this.onCreate()
        } else {
          toast.error(this.$lang.Common.NoRecordInformed)
        }
      }
    },
    onCreate () {
      loading.push()
      RegulationAutoSpecifyRepository.Create(this.data)
        .then((response) => {
          var result = this.onResultObj(response)
          if (result !== null) {
            this.onLoad(result.regulationAutoID)
          }
          this.onResult(response, true, true)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onUpdate () {
      loading.push()
      RegulationAutoSpecifyRepository.Update(this.data)
        .then((response) => {
          this.onResult(response, true, true)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      if (this.data) {
        this.data.regulationAutoID = this.objRegulationAuto.id
        this.form.regulationAutoID.value = this.objRegulationAuto.id
      }
      loading.pop()
    },
    onEditByID (ID) {
      if (ID && ID !== '00000000-0000-0000-0000-000000000000') {
        RegulationAutoSpecifyRepository.GetByID(ID)
          .then((response) => {
            var obj = this.onResultObj(response)
            if (obj !== null) {
              this.onEdit(obj)
            }
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        // this.onClear()
        // this.$emit('Edit', null)
      }
    },
    onEditByRegulationAuto (obj) {
      if (obj && obj !== null) {
        this.objRegulationAuto = obj
        if (obj && obj.id !== '00000000-0000-0000-0000-000000000000') {
          RegulationAutoSpecifyRepository.GetByRegulationAutoID(obj.id)
            .then((response) => {
              var obj = this.onResultObj(response)
              if (obj !== null) {
                this.onEdit(obj)
              }
            })
            .catch((err) => {
              this.onException(err)
            })
        } else {
          // this.onClear()
          // this.$emit('Edit', null)
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/regulation/auto/regulation/sinisterregulation.js